app.factory("Selection", ["$http",
    function ($http) {
        var Selection = {};

        Selection.list = function (params) {
            return $http.get("/selection/activation/list", {
                params: {
                    season: params.season,
                    query: params.query,
                    program: params.program,
                    gradeTemplate: params.gradeTemplate,
                    page: params.page || 1,
                    limit: params.limit || 10
                }
            }).then(function (resp) {
                return resp.data;
            });
        };

        Selection.listForHead = function (params) {
            return $http.get("/lecturer/selection/activation/list", {
                params: {
                    season: params.season,
                    query: params.query,
                    program: params.program,
                    page: params.page || 1,
                    limit: params.limit || 10
                }
            }).then(function (resp) {
                return resp.data;
            });
        };

        Selection.getActivation = function (activationId) {
            return $http.get("/selection/activation/one/" + activationId).then(function (resp) {
                return resp.data;
            });
        };

        Selection.updateActivationTemplate = function (parameters) {
            return $http.post("/selection/activation/template", {subjectActivationId: parameters.subjectActivationId}).then(function (resp) {
                return resp.data;
            });
        };

        Selection.activate = function (parameters) {
            var subjectWrapperId = parameters.subjectWrapperId;
            return $http.post("/selection/activate", {subjectWrapperId: subjectWrapperId}).then(function (resp) {
                return resp.data;
            });
        };

        Selection.activateSubject = function (parameters) {
            var subjectId = parameters.subjectId;
            return $http.post("/selection/subject/activate", {subjectId: subjectId}).then(function (resp) {
                return resp.data;
            });
        };

        Selection.deactivateSubject = function (params) {
            return $http.post("/selection/subject/deactivate", {activation: params.activation});
        };

        Selection.selectionsByActivation = function (params) {
            return $http.get("/selection/list/" + params.activationId, {
                params: {
                    grades: params.grades || false,
                    query: params.query,
                    group: params.group,
                    page: params.page || 1,
                    limit: params.limit || 10
                }
            }).then(function (resp) {
                return resp.data;
            });
        };

        Selection.addSelection = function (params) {
            return $http.post("/selection/add", {
                subjectActivation: params.subjectActivation,
                student: params.student
            }).then(function (resp) {
                return resp.data;
            });
        };

        Selection.removeSelection = function (subjectSelection) {
            return $http.post("/selection/remove", {
                subjectSelection: subjectSelection
            }).then(function (resp) {
                return resp.data;
            });
        };

        Selection.saveSubjectConfession = function (params) {
            return $http.post("/selection/confess", {
                profile: params.profile,
                score: params.score,
                name: params.name,
                subject: params.subject,
                semester: params.semester,
                selectionState: params.selectionState,
                state: params.state,
                credits: params.credits,
                result: params.result,
                confessed: params.confessed,
                subjectWrapper: params.subjectWrapper
            }).then(function () {
                return true;
            });
        };

        Selection.editSubjectSelection = function (params) {
            return $http.post("/selection/edit", {
                selectionId: params.selection,
                semester: params.semester,
                name: params.name,
                subjectWrapper: params.subjectWrapper,
                subject: params.subject,
                credits: params.credits,
                score: params.score,
                state: params.state,
                lecturers: params.lecturers,
                result: params.result
            }).then(function () {
                return true;
            });
        };

        Selection.activationsForStudent = function (params) {
            return $http.get("/selection/active/subject/" + params.studentId, {
                params: {
                    program: params.program
                }
            }).then(function (resp) {
                return resp.data;
            });

        };

        Selection.prove = function (params) {
            return $http.post("/selection/prove", {
                selection: params.selection,
                seminar: params.seminar,
                lecture: params.lecture
            }).then(function (resp) {
                return resp.data;
            });
        };

        Selection.conditionalList = function (params) {
            return $http.get("/selection/conditional/list", {
                params: {
                    page: params.page || 1,
                    limit: params.limit || 10
                }
            }).then(function (resp) {
                return resp.data;
            });
        };

        Selection.addConditionalSubject = function (params) {
            return $http.post("/selection/conditional/add", {
                startDate: params.startDate,
                endDate: params.endDate,
                conditionalName: params.conditionalName,
                program: params.program
            }).then(function (resp) {
                return resp.data;
            });
        };

        Selection.bindConditionalSubject = function (params) {
            return $http.post("/selection/conditional/bind", {
                subject: params.subject,
                conditional: params.conditional
            }).then(function (resp) {
                return resp.data;
            });
        };

        Selection.removeConditionalSubject = function (params) {
            return $http.post("/selection/conditional/remove", {
                id: params.id
            }).then(function (resp) {
                return resp.data;
            });
        };

        Selection.activationSubjectGroups = function (params) {
            var administratorId = params.administratorId;
            var activationId = params.activationId;
            return $http.post("/exams/subject/groups", {
                administratorId: administratorId,
                activationId: activationId
            }).then(function (resp) {
                return resp.data;
            });
        };

        Selection.gradeStatistics = function (params) {
            return $http.get("/selection/grade/statistics", {
                params: {
                    page: params.page,
                    limit: params.limit,
                    query: params.query,
                    student: params.student,
                    personalNo: params.personalNo,
                    level: params.level,
                    semesters: params.semesters,
                    programs: params.programs,
                    subject: params.subject,
                    faculties: params.faculties,
                    studentStates: params.studentStates,
                    selectionState: params.selectionState,
                    seasons: params.seasons
                }
            }).then(function (resp) {
                return resp.data;
            });
        };


        Selection.activationSelectionListWithGrades = function (params) {
            var paramsObject = {
                administratorId: params.administratorId,
                subjectId: params.subjectId,
                activationId: params.activationId,
                sessionGroup: params.sessionGroup || null
            };
            return $http.post("/selection/grade/list/", paramsObject).then(function (resp) {
                var data = resp.data;
                var selections = data.subjectSelections;
                var gradeTemplate = data.gradeTemplate;
                var grades = data.grades;
                var subject = data.subject;
                selections.forEach(function (selection) {
                    var finalGradeList = [];
                    var selectionGrades = grades.filter(function (e) {
                        return e.subjectSelection === selection._id
                    });
                    gradeTemplate.components.forEach(function (component) {
                        var cloned = _.cloneDeep(component);
                        if (cloned.type !== "group") {
                            var elems = selectionGrades.filter(function (e) {
                                return e.gradeComponent === component._id
                            });
                            if (elems.length > 0) {
                                cloned.grade = elems[0];
                            } else {
                                cloned.grade = null;
                            }
                            cloned.selection = selection._id;
                        }
                        finalGradeList.push(cloned);
                    });

                    finalGradeList.map(function (el) {
                        el.inlineValue = el.grade ? el.grade.absolute : "-";
                    });

                    var masterLayer = finalGradeList.filter(function (e) {
                        return e.parent === null;
                    });
                    masterLayer.map(function (el) {
                        var written = 0;
                        if (el.type === "group") {
                            written = 0;
                            el.items = finalGradeList.filter(function (e) {
                                return e.parent === el._id;
                            });
                            el.inlineValue = _.sumBy(el.items, function (o) {
                                written = written + (o.grade ? 1 : 0);
                                return o.grade ? o.grade.absolute : 0;
                            });
                            el.inlineValue = written > 0 ? Math.round(el.inlineValue * 100) / 100 : "-";

                        }
                    });

                    selection.grades = masterLayer;
                    selection.unorderedGrades = finalGradeList;

                });
                return {subject: subject, selections: selections, gradeTemplate: gradeTemplate};
            });
        };

        Selection.addGrade = function (params) {

            var gradeObject = {
                administratorId: params.administratorId,
                gradeComponent: params.gradeComponent,
                relative: params.relative,
                subjectSelection: params.subjectSelection
            };
            return $http.post("/selection/grade/add", gradeObject).then(function (resp) {
                return resp.data;
            });
        };

        Selection.editGrade = function (params) {

            var gradeComponentObject = {
                grade: params.grade,
                administratorId: params.administratorId,
                relative: params.relative,
                comment: params.comment
            };
            return $http.post("/selection/grade/edit", gradeComponentObject).then(function (resp) {
                return resp.data;
            });
        };

        Selection.deleteGrade = function (params) {

            var gradeComponentObject = {
                grade: params.grade,
                administratorId: params.administratorId
            };
            return $http.post("/selection/grade/delete", gradeComponentObject).then(function (resp) {
                return resp.data;
            });
        };

        Selection.sessions = function (activationId) {
            return $http.get("/selection/sessions/" + activationId).then(function (resp) {
                return resp.data;
            })
        };

        Selection.archiveSelections = function (selections) {
            return $http.post("/selection/archive", selections).then(function (resp) {
                return resp.data;
            });
        };

        Selection.archiveOneSelection = function (params) {
            return $http.post("/selection/archive/one", params).then(function (resp) {
                return resp.data;
            });
        };

        Selection.unArchiveOneSelection = function (params) {
            return $http.post("/selection/un-archive/one", params).then(function (resp) {
                return resp.data;
            });
        };

        return Selection;
    }
]);
